$(document).ready(function (e) {
    $(".upload_plus").hover(function () {
            $("#bericht_foto").removeClass('fa-picture-o');
            $("#bericht_foto").addClass('fa-plus-circle');
        },
        function () {
            $("#bericht_foto").removeClass('fa-plus-circle');
            $("#bericht_foto").addClass('fa-picture-o');
        }
    );

//trigger Img upload
    $("#bericht_foto").click(function () {
        $("#imgInp").click();
    });

    //Remove image
    $("#bericht_foto_verwijder").click(function () {
        cancelImage();
        $("#imgOrig").val("");
    });

    $("#bericht_cancel").click(function () {
        cancelImage()
    });

//imagePreview
    function readURL(input) {

        if (input.files && input.files[0]) {
            let reader = new FileReader();

            reader.onload = function (e) {
                $('#img_field').attr('src', e.target.result);
            };
            $("#bericht_foto").hide();
            $("#img_field").show();
            $("#bericht_foto_verwijder").show();
            reader.readAsDataURL(input.files[0]);
        }
    }

    $("#imgInp").change(function () {
        readURL(this);
    });
//Edit
    //Show loaded image
    if ($("#img_field").attr("src") !== "") {
        $("#bericht_foto").hide();
        $("#img_field").show();
        $("#bericht_foto_verwijder").show();
    }
    //Reload on cancel
    $("#bericht_cancel_edit").click(function () {
        location.reload();
    });

//Save info
    let regexARSuc = /\/artikels\/index\/Save\/Success/;
    let regexARFail = /\/artikels\/index\/Save\/Failed$/;
    let regexARFailUpload = /\/artikels\/index\/Save\/Failed\/Upload/;

    if (regexARSuc.test(window.location.pathname)) {
        window.history.replaceState({}, 'KBSV - Artikels', '/Artikels');
        $(".save_succ").fadeIn(1000).delay(5000).fadeOut(1000);
    }


    if (regexARFail.test(window.location.pathname)) {
        window.history.replaceState({}, 'KBSV - Artikels', '/Artikels');
        $(".save_fail").fadeIn(1000).delay(5000).fadeOut(1000);
    }


    if (regexARFailUpload.test(window.location.pathname)) {
        window.history.replaceState({}, 'KBSV - Artikels', '/Artikels');
        $(".save_fail_upload").fadeIn(1000).delay(5000).fadeOut(1000);
    }
});

//Functions
//Cancel Image
function cancelImage() {
    $("#imgInp").val("");
    $('#img_field').attr('src', "");
    $("#img_field").hide();
    $("#bericht_foto_verwijder").hide();
    $("#bericht_foto").show();
}


//////////////////
// WEBPACK FOOTER
// ./js/artikels.js
// module id = 13
// module chunks = 0